var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"df-news"}},[_c('p',{staticClass:"text-justify"},[_vm._v(" "+_vm._s(_vm.$t("content"))+" ")]),_c('br'),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":require("@/assets/news/postcast.png"),"alt":"postcast"}}),_c('a',{attrs:{"href":"https://www.youtube.com/watch?v=mY09M9n3_ds"}},[_vm._v(" ver mas ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }